module.exports = __webpack_public_path__ + "img/5.48be8629.svg";